(function () {
  function initBrands(section) {
    if (!section || section.dataset.brandsInit) return;
    section.dataset.brandsInit = "1";

    var track = section.querySelector("[data-brands-track]");
    var viewport = section.querySelector(".brands__viewport");
    var originals = Array.prototype.slice.call(
      section.querySelectorAll("[data-brands-item]")
    );
    if (!track || !viewport || !originals.length) return;

    var prev = section.querySelector("[data-brands-prev]");
    var next = section.querySelector("[data-brands-next]");
    var gallery = section.querySelector("[data-brands-gallery]");
    var img1 = section.querySelector('[data-brands-img="1"]');
    var img2 = section.querySelector('[data-brands-img="2"]');
    var autoplaySec = parseInt(section.getAttribute("data-autoplay"), 10) || 0;

    var N = originals.length;
    var sideSets = 3; /* copies on each side → always filled left & right */
    var totalSets = 2 * sideSets + 1;

    /* Build looped track: totalSets copies of the brand set */
    track.innerHTML = "";
    var items = [];
    for (var s = 0; s < totalSets; s++) {
      for (var k = 0; k < N; k++) {
        var clone = originals[k].cloneNode(true);
        clone.classList.remove("is-active");
        track.appendChild(clone);
        items.push(clone);
      }
    }

    var mid = sideSets * N;
    var pos = mid; /* logical index of active (brand 0) */
    var timer = null;
    var normTimer = null;

    function center(animate) {
      if (!animate) track.classList.add("no-anim");
      var item = items[pos];
      var tx = viewport.clientWidth / 2 - (item.offsetLeft + item.offsetWidth / 2);
      track.style.transform = "translate3d(" + tx + "px,0,0)";
      if (!animate) {
        track.offsetHeight; /* reflow */
        track.classList.remove("no-anim");
      }
    }

    function highlight() {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle("is-active", i === pos);
      }
    }

    function updateGallery() {
      if (!gallery) return;
      var item = items[pos];
      var n1 = item.getAttribute("data-img1");
      var n2 = item.getAttribute("data-img2");
      gallery.classList.add("is-fading");
      /* Swap sources while faded, then fade back in ONLY once the new
         images have finished loading (no pop-in of a half-loaded image). */
      setTimeout(function () {
        var remaining = 0;
        var finished = false;
        var safety;
        function finish() {
          if (finished) return;
          finished = true;
          clearTimeout(safety);
          requestAnimationFrame(function () { gallery.classList.remove("is-fading"); });
        }
        function load(img, src, alt) {
          if (!img || !src) return;
          remaining++;
          var done = false;
          function d() { if (done) return; done = true; img.onload = img.onerror = null; if (--remaining <= 0) finish(); }
          img.onload = d;
          img.onerror = d;
          img.src = src;
          img.alt = alt;
          if (img.complete) d();
        }
        load(img1, n1, item.getAttribute("data-alt1") || "");
        load(img2, n2, item.getAttribute("data-alt2") || "");
        safety = setTimeout(finish, 2000); /* never stay stuck faded */
        if (remaining === 0) finish();
      }, 300);
    }

    /* After the slide settles, jump (no-anim) back to the canonical middle
       set so both sides stay populated forever. Same brand, same neighbours
       → the jump is invisible. */
    function scheduleNormalize() {
      clearTimeout(normTimer);
      normTimer = setTimeout(function () {
        var np = pos;
        while (np < mid) np += N;
        while (np >= mid + N) np -= N;
        if (np !== pos) {
          pos = np;
          highlight();
          center(false);
        }
      }, 600);
    }

    function setActive(p, animate, skipGallery) {
      pos = p;
      highlight();
      center(animate !== false);
      if (!skipGallery) updateGallery();
      if (animate !== false) scheduleNormalize();
    }

    function resetAuto() {
      if (timer) clearInterval(timer);
      if (autoplaySec > 0) {
        timer = setInterval(function () { setActive(pos + 1, true); }, autoplaySec * 1000);
      }
    }
    function go(dir) { setActive(pos + dir, true); resetAuto(); }

    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    items.forEach(function (it, idx) {
      it.addEventListener("click", function () { setActive(idx, true); resetAuto(); });
    });

    /* swipe / drag */
    var down = false, startX = 0, moved = 0;
    function ptrDown(x) { down = true; startX = x; moved = 0; if (timer) clearInterval(timer); }
    function ptrMove(x) { if (down) moved = x - startX; }
    function ptrUp() {
      if (!down) return;
      down = false;
      if (Math.abs(moved) > 40) setActive(pos + (moved < 0 ? 1 : -1), true);
      resetAuto();
    }
    viewport.addEventListener("mousedown", function (e) { ptrDown(e.clientX); });
    window.addEventListener("mousemove", function (e) { ptrMove(e.clientX); });
    window.addEventListener("mouseup", ptrUp);
    viewport.addEventListener("touchstart", function (e) { ptrDown(e.touches[0].clientX); }, { passive: true });
    viewport.addEventListener("touchmove", function (e) { ptrMove(e.touches[0].clientX); }, { passive: true });
    viewport.addEventListener("touchend", ptrUp);

    section.addEventListener("mouseenter", function () { if (timer) clearInterval(timer); });
    section.addEventListener("mouseleave", resetAuto);

    var rt;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () { center(false); }, 120);
    });

    highlight();
    setActive(mid, false, true); /* center brand 0, no gallery fade on load */
    window.addEventListener("load", function () { center(false); });
    resetAuto();
  }

  function initAll() {
    document.querySelectorAll("[data-brands]").forEach(initBrands);
  }
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (e) {
    var s = e.target.querySelector ? e.target.querySelector("[data-brands]") : null;
    if (s) initBrands(s);
  });
})();
